// extracted by mini-css-extract-plugin
export default {"container":"product-types-splitted_container__TegtX","stickyFix":"product-types-splitted_stickyFix__W5fPb","placeHolderShimmer":"product-types-splitted_placeHolderShimmer__B7pPE"};